<template>
	<header id="GlobalHeader" class="view-layout-header">
		<div
			class="chalky branding-standard branding-chalky-wordmark on-dark"
			mode="dark"
			size="xs"
			v-if="isHomePage"
			v-on:click="Handle_OnClickHeader"
		>
			<h2>ChalkySticks</h2>
		</div>

		<div v-else>
			<button
				class="control round size-medium type-left background-transparent filter-invert"
				v-on:click="Handle_OnClickBack"
			>
				Back
			</button>
		</div>

		<ChalkyAuthenticationNavigation
			v-bind:authModel="$store.getters['authentication/authModel']"
			v-if="$feature.all(['auth', 'auth_login'])"
		/>
	</header>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewLayoutHeader extends ViewBase {
		/**
		 * @return boolean
		 */
		protected get isHomePage(): boolean {
			return this.$route.name === 'PageHome';
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickBack(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$router.go(-1);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickHeader(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$router.push({ name: 'PageHome' });
		}
	}
</script>

<style lang="scss">
	.view-layout-header {
		align-items: center;
		background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, var(--chalky-blue-4) 90%);
		display: flex;
		justify-content: space-between;
		margin-top: -0.5rem;
		padding: var(--padding);

		.authentication-navigation .logged-out button {
			padding: 0;
		}

		.branding-chalky-wordmark {
			cursor: pointer;
		}
	}

	// Media Queries
	// ---------------------------------------------------------------------------

	@media screen and (orientation: landscape) {
		.view-layout-header {
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.5s ease-in-out;
		}
	}
</style>
